'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = '2.5.2';


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/docsearch.js/dist/npm/src/lib/version.js
// module id = ../../node_modules/docsearch.js/dist/npm/src/lib/version.js
// module chunks = 6